<script>
export default {
    name: 'TagsBadges',

    functional: true,

    props: {
        tags: {type: Array, required: true},
        none: {type: String, default: ''},
    },

    render(createElement, {props, data}) {
        if (props.tags.length === 0) {
            data.staticClass = ['text-muted', data.staticClass].join(' ');

            return createElement('em', data, [props.none]);
        }

        const children = props.tags.map((tag) => [
            createElement('span', {
                key: tag.id,
                staticClass: `badge badge-${tag.color}`,
            }, [tag.name]),
            ' ',
        ]);

        return createElement('span', data, children);
    },
};
</script>
